<dx-popup [width]="1250" [height]="740" [showTitle]="false" [title]="title" [dragEnabled]="false"
  [closeOnOutsideClick]="false" [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <h5 class="ap-green">Edit Site Ownership</h5>
    <div id="form-container">
      <dx-form id="form" [colCount]="10" [formData]="frmCustomerSite" [showColonAfterLabel]="true">
        <dxi-item [colSpan]="4">
          <dxo-label text="Search Companies"></dxo-label>
          <dx-text-box [(value)]="companyName" [showClearButton]="true"></dx-text-box>
        </dxi-item>
        <dxi-item [colSpan]="4" cssClass="extraPadding">
          <dx-button text="Search" type="default" [useSubmitBehavior]="false" (onClick)="searchCompanies()">
          </dx-button>
        </dxi-item>
        <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
      </dx-form>
      <label style="color:red" *ngIf="showCompanyErrorMsg">
        Please enter atleast three characters before
        searching
      </label>
      <div class="dx-field">
        <dx-check-box [(value)]="showMultiNationalCompanies"></dx-check-box>
        <div class="dx-field-label">&nbsp;&nbsp;Only show multinational companies</div>
      </div>
      <div class="row>"></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-5">
          <dx-data-grid #CompanyGrid id="CompanyGrid" [dataSource]="companyList" keyExpr="companyId"
            class="fixGridHeight" [selectedRowKeys]="[]" [allowColumnReordering]="true" [showRowLines]="true"
            [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
            [columnHidingEnabled]="false" [allowColumnResizing]="true" (onRowInserting)="saveCompany($event)"
            (onSelectionChanged)="companiesSelectionChangedHandler($event)" (onRowUpdating)="saveCompany($event)">

            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
              [showInfo]="true" [showNavigationButtons]="false">
            </dxo-pager>
            <dxo-toolbar>
              <dxi-item name="groupPanel"></dxi-item>
              <dxi-item location="after">
                <dx-button text="Add New Owner" type="default" (onClick)="addNewOwner($event)"></dx-button>
              </dxi-item>
            </dxo-toolbar>
            <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true"></dxo-editing>

            <dxi-column dataField="companyName" [width]="300" dataType="string" caption="Company">
              <dxi-validation-rule type="required" message="Company is required"></dxi-validation-rule>
            </dxi-column>
            <dxi-column dataField="companyType" [width]="120" dataType="string" caption="Company Type">
            </dxi-column>
          </dx-data-grid>
        </div>
        <div class="col-2 addDeletePadding">
          <div class="row" style="padding-bottom:15%">
            <dx-button text="Add ->" type="default" [disabled]="disableAddBtn" [useSubmitBehavior]="false"
              (onClick)="addCustomerSite()"></dx-button>
          </div>
          <div class="row">
            <dx-button text="Delete >-" type="default" [disabled]="disableDeleteBtn" [useSubmitBehavior]="false"
              (onClick)="removeCustomerSite()"></dx-button>
          </div>
        </div>
        <div class="col-5" style="padding-left:0% ;">
          <label class="dx-field-label" style="float:none">Company Owners for this Site</label>
          <dx-data-grid #CompanyOwnershipGrid id="CompanyOwnershipGrid" [dataSource]="companySites" keyExpr="companyId"
            [selectedRowKeys]="[]" [allowColumnReordering]="true" [showRowLines]="true" [showColumnLines]="true"
            [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [columnHidingEnabled]="false"
            [allowColumnResizing]="true" (onCellDblClick)="onCellDblClick($event)"
            (onSelectionChanged)="companyOwnSelectionChangedHandler($event)">

            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-editing mode="row" [allowUpdating]="true" [useIcons]="true"></dxo-editing>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxi-column dataField="companyName" [allowEditing]="false" [width]="300" dataType="string"
              caption="Company"></dxi-column>
            <dxi-column dataField="companyOwnerSharePercent" [width]="95" dataType="string" caption="% Owned">
              <dxi-validation-rule type="pattern" [pattern]="decimalOnePlace"
                message="Only numerics with one decimal place is allowed">
              </dxi-validation-rule>
            </dxi-column>
            <dxo-summary>
              <dxi-total-item column="companyOwnerSharePercent" summaryType="sum" alignment="left"
                displayFormat="Total: {0}">
              </dxi-total-item>
            </dxo-summary>
          </dx-data-grid>
          <div>
            <label style="color:red;padding-top:2%;" *ngIf="showPercentageOwnerErrorMsg">
              The % Owned fields
              must total 100%
            </label>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
      </div>
    </div>
    <div>
      <dx-button text="Save Close" type="default" (onClick)="onSaving(true)"></dx-button>
      &nbsp;
      <dx-button class="ap-discard-button" text="Cancel" (onClick)="onClickCancel()"></dx-button>
    </div>
  </div>
</dx-popup>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
  [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>